




import { defineComponent, PropType } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";
import { IMoreMenuItem } from "@/views/PageMore/config";

export default defineComponent({
  name: "MoreMenuItemSeparator",
  components: { BaseIcon },
  props: {
    item: { type: Object as PropType<IMoreMenuItem>, required: true },
  },
});
